'use client'

// IMPORTANT: Import appkit-init FIRST to ensure createAppKit runs before any hooks
import '@/lib/appkit-init'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider, type State } from 'wagmi'
import { SessionProvider } from 'next-auth/react'
import { wagmiAdapter } from './wagmi-config'
import { TronProvider } from './tron-provider'
import { TonProvider } from './ton-provider'
import { ReactNode, useState } from 'react'

interface Web3ProviderProps {
    children: ReactNode
    initialState?: State
}

export function Web3Provider({ children, initialState }: Web3ProviderProps) {
    const [queryClient] = useState(() => new QueryClient())

    return (
        <SessionProvider refetchOnWindowFocus={false} refetchInterval={5 * 60}>
            <WagmiProvider config={wagmiAdapter.wagmiConfig} initialState={initialState}>
                <QueryClientProvider client={queryClient}>
                    <TronProvider>
                        <TonProvider>
                            {children}
                        </TonProvider>
                    </TronProvider>
                </QueryClientProvider>
            </WagmiProvider>
        </SessionProvider>
    )
}
